import React from 'react';
// import useRequestsTypes from '@ubeya/shared/hooks/generic/useRequestsTypes';

const TypeRendererDetails = () => {
  return <></>;
  // const { mappedRequestsTypes } = useRequestsTypes();
  // const { color } = mappedRequestsTypes?.[typeId]?.kinds?.[data?.jobTypeId] || {};

  // return <span style={{ color }}>Total days left : 10</span>;
};

export default TypeRendererDetails;
